import * as auth from './auth';
import * as authors from './authors';
import * as books from './books';
import * as categories from './categories';
import * as languages from './languages';
import * as publishers from './publishers';

export * from './dto';

export const Api = {
  auth,
  categories,
  authors,
  publishers,
  books,
  languages,
};
